module.exports = __webpack_public_path__ + "img/interactive-hero-slider-honda.b5e47680.png";